import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["view", "children", "className", "icon", "type", "iconClassName", "label", "innerRef", "highlightOnHover"];
import React from 'react';
import PropTypes from 'prop-types';
import { Button as AntdButton } from 'antd';
import cx from 'classnames';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';

// import withAnalyticsContext from '../../organisms/analytics/analyticsContext/withAnalyticsContext';
// import withAnalyticsEvents from '../../organisms/analytics/analyticsEvent/withAnalyticsEvent';
// import createAndFireEvent from '../../organisms/analytics/analyticsEvent/createAndFireEvent';

import styles from './button.module.scss';
var BUTTON_VIEWS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  ICON: 'icon',
  LINK: 'link'
};
function Button(_ref) {
  var _cx;
  var view = _ref.view,
    children = _ref.children,
    className = _ref.className,
    icon = _ref.icon,
    type = _ref.type,
    iconClassName = _ref.iconClassName,
    label = _ref.label,
    innerRef = _ref.innerRef,
    highlightOnHover = _ref.highlightOnHover,
    rest = _objectWithoutProperties(_ref, _excluded);
  var buttonClassNames = cx((_cx = {}, _defineProperty(_cx, styles.primaryButton, view === BUTTON_VIEWS.PRIMARY), _defineProperty(_cx, styles.secondaryButton, view === BUTTON_VIEWS.SECONDARY), _defineProperty(_cx, styles.tertiaryButton, view === BUTTON_VIEWS.TERTIARY), _defineProperty(_cx, styles.iconButton, view === BUTTON_VIEWS.ICON), _defineProperty(_cx, styles.linkButton, view === BUTTON_VIEWS.LINK), _defineProperty(_cx, styles.tertiaryButtonHover, view === BUTTON_VIEWS.TERTIARY && highlightOnHover), _cx));
  return /*#__PURE__*/React.createElement(AntdButton, _extends({
    className: cx(buttonClassNames, className),
    type: view,
    htmlType: type,
    ref: innerRef
  }, rest), icon ? /*#__PURE__*/React.createElement("span", {
    className: cx(icon, iconClassName)
  }) : label || children);
}

// const ButtonWithAnalyticsContext = withAnalyticsContext({
//   componentName: 'button',
// })(
//   withAnalyticsEvents({
//     onClick: createAndFireEvent('tekion-components')({
//       action: 'clicked',
//       componentName: 'button',
//     }),
//   })(Button),
// );

var ButtonWithRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    innerRef: ref
  }));
});
ButtonWithRef.VIEW = BUTTON_VIEWS;
ButtonWithRef.propTypes = {
  view: PropTypes.string,
  iconClassName: PropTypes.string,
  children: PropTypes.any,
  label: PropTypes.string,
  highlightOnHover: PropTypes.bool
};
ButtonWithRef.defaultProps = {
  view: BUTTON_VIEWS.SECONDARY,
  iconClassName: EMPTY_STRING,
  children: EMPTY_STRING,
  label: EMPTY_STRING,
  highlightOnHover: true
};
export default ButtonWithRef;